import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './GeneralInformation.css';
import { useNavigate } from 'react-router-dom';
import logo_agroinsider_color from '../../assets/logo-agroinsider-color.svg';
import img_farm_profile from '../../assets/perfil_da_herdade_inicio.svg';
import logo_footer_color from '../../assets/logos_footer_color.svg';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';

const GeneralInformation = ({ generalInfo, setGeneralInfo, setReset }) => {
    const [formData, setFormData] = useState(generalInfo);
    const { t } = useTranslation();
    const navigate = useNavigate(); // Para navegação programática


    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNavigateBack = (e) => {
        setReset(true);
        navigate('/');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setGeneralInfo(formData);
        navigate('/farm-type');
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className='form-background'>
                <div className='div-agroinsider-logo'>
                    <img src={logo_agroinsider_color} alt="AgroInsider Logo" className="logo" />
                </div>
                <div className='div-page-logo'>
                    <img className='img-page-logo' src={img_farm_profile} alt="AgroInsider Logo" />
                </div>
                <div className='farm-profile-description'>
                    <span className='farm-profile-title'>{t('FarmProfile.title')}</span>
                    <p className='farm-profile-description-text'>{t('FarmProfile.description')}</p>
                </div>
                <div className="form-profile-form">
                    <div className="form-group">
                        <label className='form-input-title' htmlFor="farmName">{t('FarmProfile.farmName')}</label>
                        <input
                            className='form-input'
                            type="text"
                            name='farmName'
                            id="farmName"
                            value={formData.farmName}
                            onChange={handleChange}
                        // required
                        />
                    </div>

                    {/* <div className="form-group">
                        <label className='form-input-title' htmlFor="location">{t('FarmProfile.location')}</label>
                        <RegionDistrictSelect value={formData.farmLocation} onChange={handleSetLocation} />
                    </div> */}

                    <div className="form-group">
                        <label className='form-input-title' htmlFor="size">{t('FarmProfile.size')}</label>
                        <input
                            className='form-input'
                            name='farmSize'
                            type="number"
                            id="size"
                            value={formData.farmSize}
                            onChange={handleChange}
                        // required
                        />
                    </div>
                </div>
                <div className='form-group-bottom-buttons'>
                    <div className="form-group-buttons">
                        <button className='form-back-button' onClick={() => handleNavigateBack()}>{t('quit')}</button>
                        <button className="form-next-button" type="submit">{t('AnimalProduction.submit')}</button>
                    </div>
                </div>
                <LanguageSwitcher />
                <div className='div-logo-footer-color'>
                    <img src={logo_footer_color} alt="AgroInsider Logo" className="logo" />
                </div>
            </div>
        </form>
    );
}

export default GeneralInformation;
